/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Home from "./Secciones/Seccion_Home";
import {useCarritoFlotante} from "../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";

const Pagina = () => {
    const {sCell} = useResponsive()
    const {CarritoFlotante} = useCarritoFlotante();


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Router>
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1, mt: -16}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? -8 : 8}}>
                    <Footer/>
                </Grid>

                <CarritoFlotante/>

            </Router>

        </Grid>
    )

}
export default Pagina    